<template>
  <div class="container">
    <div class="border-bottom"></div>
    <div class="socials">
      <social-media-icon v-for="social in socialMedias" :social="social" :key="social.name" />
    </div>
  </div>
</template>

<script>
import SocialMediaIcon from "./social-media-icon"
import socials from "@/constants/social-media.js"
export default {
  components: {
    SocialMediaIcon
  },
  data: () => {
    return {
      socialMedias: socials.ALL_SOCIALS,
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/views/project-synthecite/styles/variables.scss";

.container {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: black;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.border-bottom {
  width: 100%;
  height: 1vh;
  max-height: 5px;
  background-color: $text-color;
}
.header {
  font-size: 50px;
}

.socials {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 90%;
  height: 8vh;
}
</style>

<style>
.socials .icon {
  font-size: 7vh !important;
}
.socials .disabled {
  display: none !important;
}
</style>